import React from 'react';
import Component from './Component';
import getRandomString from '../../utils/getrandomstring';

export default class RadioList extends Component {

	constructor(props)
	{
		super(props);
		this.uid = getRandomString();
	}

	handleChange(e) {
		let value = e.target.value;
		if (value) {
			value = parseInt(value);
		}

		if (this.props.onChange) {
			this.props.onChange(value)
		}
		if (this.props.onBlur) {
			this.props.onBlur(value)
		}
	}

	render() {
		let options = this.props.options;
		if (options.asArray) {
			options = options.asArray();
		}
		const inputs = options.map((item) => {
			return <label key={item.id}>
						<input checked={item.id == this.props.value}
								 type="radio"
								 value={item.id}
								 name={this.uid}
								 onChange={(e) => this.handleChange(e)}
								 key={item.id} />{' '}
							{item.title}
					</label>;
		});

		return (
			<span className="radiolist">
				{inputs}
			</span>
		)
	}
}


// WEBPACK FOOTER //
// ./src/reactis/reactis-inputs/RadioListBase.js